import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import { extendedTestimonials } from '../data/testimonials';
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-sage-light" data-id="element-80" data-mp="bjmfuaxnuwpf">
      <div className="max-w-6xl mx-auto" data-id="element-81" data-mp="bitfpst7j5g9">
        <div className="text-center mb-16" data-id="element-82" data-mp="gbeaoxnunold">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-ink" data-id="element-83" data-mp="gcfovb05wr7b">
            ⭐ What Pickleball Instructors Who Already Have the System Are Saying
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-84" data-mp="q7pltkbpe8e8">
          {extendedTestimonials.map((testimonial, index) => <motion.article key={testimonial.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-white border border-sage p-8 rounded-2xl relative shadow-sm ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-85" data-mp="u8jfkubtuhf1" data-mpi={index}>
              <Quote className="absolute top-6 right-6 text-gold/20" size={48} data-id="element-86" data-mp="380fsegv7u354" />
              <div className="flex gap-1 text-gold mb-6" aria-label="5 out of 5 stars" data-id="element-87" data-mp="37ybgpcr2rzua">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-88" data-mp="2z0iy9zq24c2o" data-mpi={starIndex} />)}
              </div>
              <p className="text-charcoal italic mb-8 relative z-10 leading-relaxed" data-id="element-89" data-mp="3voz12xi6ghxq">
                “{testimonial.text}”
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-90" data-mp="3rmaqoldtf2yn">
                <div className="w-12 h-12 rounded-full bg-forest flex items-center justify-center text-cream-light font-bold text-lg" data-id="element-91" data-mp="3mo959tsx2rk0">
                  {testimonial.initials}
                </div>
                <div data-id="element-92" data-mp="2bb6vbhlbp08t">
                  <div className="font-bold text-ink" data-id="element-93" data-mp="2bbgiyyiwavbc">{testimonial.name}</div>
                  <div className="text-xs text-gold-dark" data-id="element-94" data-mp="26aap2xdi1208">{testimonial.role}</div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}